import { Typography, useMediaQuery } from '@mui/material';
import { MicrophoneIcon } from '../../../assets/customIcons';
import { PlusGrayIconNew, ShareIcon } from '../../../assets/images';
import { ReactComponent as LocationIcon } from '../../../assets/images/LocationIcon.svg';
import { ReactComponent as MessageIcon } from '../../../assets/images/annotation-dots.svg';
import { ReactComponent as LeftArrow } from '../../../assets/images/arrow-left.svg';
import { ReactComponent as VerifiedIcon } from '../../../assets/images/check-verified.svg';
import { ReactComponent as CrossIconSVG } from '../../../assets/images/crossCircleIocn.svg';
import { ReactComponent as EditIcon } from '../../../assets/images/edit-icon.svg';
import { ReactComponent as LinkSvg } from '../../../assets/images/linkIcon.svg';
import { ReactComponent as MailIcon } from '../../../assets/images/mailSvg.svg';
import { Download } from '../../../builderPackage/assets/svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { info, secondary } from '../../../theme/colors';
import { PrintIconSVG } from '../../spareParts/purchaseRequistion/assets/customIcons';
import { getPartListAPI } from '../services/apiCall';
import { ServiceEstimateKeys } from '../services/entity';
var ServiceEstimateDetails = function () {
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var generalTab = [{
            type: FormItemTypes.CardComponent,
            label: '',
            name: 'general',
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            value: 'Customer details',
                            columnSize: true,
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.Box,
                            label: '',
                            name: '',
                            value: null,
                            columnSize: 12,
                            sx: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px',
                                border: '1px solid ',
                                paddingY: '16px',
                                borderRadius: '12px',
                                borderColor: secondary[200]
                            },
                            elements: [{
                                    type: FormItemTypes.Box,
                                    name: '',
                                    display: 'flex',
                                    columnSize: 12,
                                    paddingInline: '16px',
                                    gap: '8px',
                                    elements: [{
                                            type: FormItemTypes.Avatar,
                                            name: '',
                                            columnSize: 0
                                        }, {
                                            type: FormItemTypes.Box,
                                            name: '',
                                            columnSize: 12,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '4px',
                                            elements: [{
                                                    type: FormItemTypes.Box,
                                                    name: '',
                                                    display: 'flex',
                                                    columnSize: 12,
                                                    sx: {
                                                        justifyContent: 'space-between'
                                                    },
                                                    height: '20px',
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            value: 'Riya Raheja',
                                                            columnSize: true,
                                                            fontWeight: 'medium'
                                                        }, {
                                                            type: FormItemTypes.Icon,
                                                            name: '',
                                                            children: /*#__PURE__*/ React.createElement(EditIcon, {
                                                                color: secondary[600]
                                                            }),
                                                            columnSize: 0,
                                                            sx: {
                                                                cursor: 'pointer',
                                                                height: '20px',
                                                                width: '20px'
                                                            }
                                                        }]
                                                }, {
                                                    type: FormItemTypes.Box,
                                                    name: '',
                                                    display: 'flex',
                                                    columnSize: 12,
                                                    gap: '8px',
                                                    height: '18px',
                                                    elements: [{
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            display: 'flex',
                                                            columnSize: 0,
                                                            gap: '4px',
                                                            elements: [{
                                                                    type: FormItemTypes.Typography,
                                                                    name: '',
                                                                    columnSize: 0,
                                                                    value: '90875205812',
                                                                    fontSize: 'sm',
                                                                    fontWeight: 'normal',
                                                                    color: secondary[500]
                                                                }]
                                                        }, {
                                                            type: FormItemTypes.Divider,
                                                            name: 'name',
                                                            variant: 'fullWidth',
                                                            orientation: 'vertical',
                                                            columnSize: 0
                                                        }, {
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            display: 'flex',
                                                            columnSize: 0,
                                                            gap: '4px',
                                                            elements: [{
                                                                    type: FormItemTypes.Typography,
                                                                    name: '',
                                                                    columnSize: 0,
                                                                    value: '90875205812',
                                                                    fontSize: 'sm',
                                                                    fontWeight: 'normal',
                                                                    color: secondary[500]
                                                                }, {
                                                                    type: FormItemTypes.Icon,
                                                                    name: '',
                                                                    children: /*#__PURE__*/ React.createElement(VerifiedIcon, null),
                                                                    columnSize: 0,
                                                                    sx: {
                                                                        color: info[500],
                                                                        p: 0,
                                                                        mt: '2px'
                                                                    }
                                                                }]
                                                        }]
                                                }]
                                        }]
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: 'name',
                                    variant: 'fullWidth',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Box,
                                    name: '',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    columnSize: 12,
                                    paddingInline: '16px',
                                    gap: '8px',
                                    elements: [{
                                            type: FormItemTypes.Box,
                                            name: '',
                                            display: 'flex',
                                            columnSize: 12,
                                            gap: '8px',
                                            alignItems: 'center',
                                            elements: [{
                                                    type: FormItemTypes.IconButton,
                                                    name: '',
                                                    children: /*#__PURE__*/ React.createElement(MailIcon, null),
                                                    columnSize: 0,
                                                    sx: {
                                                        color: secondary[500],
                                                        paddingInline: 0
                                                    }
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    columnSize: true,
                                                    value: 'riyaraheja@gmail.com',
                                                    color: secondary[500],
                                                    fontSize: 'sm',
                                                    fontWeight: 'normal'
                                                }]
                                        }, {
                                            type: FormItemTypes.Box,
                                            name: '',
                                            display: 'flex',
                                            columnSize: 12,
                                            gap: '8px',
                                            alignItems: 'center',
                                            elements: [{
                                                    type: FormItemTypes.IconButton,
                                                    name: '',
                                                    children: /*#__PURE__*/ React.createElement(LocationIcon, null),
                                                    columnSize: 0,
                                                    sx: {
                                                        paddingInline: 0
                                                    }
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    columnSize: true,
                                                    value: 'Ganga Home, Row House No.1/2, next to Bank of India, Viman Nagar, Pune,',
                                                    color: secondary[500],
                                                    fontSize: 'sm',
                                                    fontWeight: 'normal'
                                                }]
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            value: 'Select vehicle',
                            columnSize: true,
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.Box,
                            label: '',
                            name: '',
                            value: null,
                            columnSize: 12,
                            sx: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px',
                                border: '1px solid',
                                padding: '16px',
                                borderRadius: '12px',
                                borderColor: secondary[200]
                            },
                            elements: [{
                                    type: FormItemTypes.Box,
                                    name: '',
                                    columnSize: 12,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            value: 'MH12PY0987',
                                            fontWeight: 'medium',
                                            columnSize: true
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            value: 'Bajaj RE CNG 4S Fi (00AF21)',
                                            fontWeight: 'normal',
                                            color: secondary[500],
                                            columnSize: true
                                        }]
                                }, {
                                    type: FormItemTypes.Box,
                                    name: '',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '4px',
                                    columnSize: 12,
                                    borderRadius: '8px',
                                    bgcolor: secondary[50],
                                    padding: '8px 12px',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            label: 'Engine no.:',
                                            value: 'AZXWME51553',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 0
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            label: 'Chassis no.:',
                                            value: 'MD2DDDZZZMWL36200',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 0
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            label: 'Date of sale:',
                                            value: '27-01-2023',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 0
                                        }]
                                }, {
                                    type: FormItemTypes.Box,
                                    name: '',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    columnSize: 12,
                                    elements: [{
                                            type: FormItemTypes.Button,
                                            name: '',
                                            variant: 'text',
                                            children: 'Vehicle history',
                                            columnSize: 0
                                        }]
                                }]
                        }]
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Service Details',
            name: 'ServiceDetails',
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.NumberInput,
                    label: 'Odometer',
                    name: '',
                    value: null,
                    required: true
                }, {
                    type: FormItemTypes.SingleSelect,
                    label: 'Service type',
                    name: 'Servicetype',
                    placeholder: 'Select service type',
                    required: true
                }, {
                    type: FormItemTypes.SingleSelect,
                    label: 'Service Advisor',
                    name: 'ServiceAdvisor',
                    placeholder: 'Select service advisor',
                    required: true
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Campaign details',
            name: 'CampaignDetails',
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.SingleSelect,
                    name: '',
                    label: 'Campaign',
                    placeholder: 'Select campaign'
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'Coupon code',
                    label: 'Coupon code'
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Customer Complaints',
            name: '',
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.TextInput,
                    label: '',
                    placeholder: 'Enter descripation...',
                    name: 'CustomerComplaints',
                    value: null,
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 12,
                    minRows: 5.5,
                    multiline: true
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 12,
                    display: 'grid',
                    gap: '20px',
                    elements: [{
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Button,
                                    name: '',
                                    columnSize: 0,
                                    sx: {
                                        height: '72px',
                                        width: '77px',
                                        border: '1px dashed ',
                                        borderColor: secondary[200],
                                        borderRadius: '8px',
                                        bgcolor: '#FFFFFF',
                                        padding: '8px',
                                        gap: '4px',
                                        color: secondary[600],
                                        display: 'flex',
                                        flexDirection: 'column',
                                        mr: 2
                                    },
                                    children: 'Upload',
                                    startIcon: /*#__PURE__*/ React.createElement("img", {
                                        style: {
                                            paddingLeft: '5px'
                                        },
                                        src: PlusGrayIconNew,
                                        alt: "",
                                        loading: "lazy"
                                    })
                                }]
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            columnSize: 12,
                            justifyContent: 'space-between',
                            elements: [{
                                    type: FormItemTypes.Box,
                                    name: '',
                                    display: 'flex',
                                    columnSize: 0,
                                    gap: '16px',
                                    elements: [{
                                            type: FormItemTypes.IconButton,
                                            name: '',
                                            children: /*#__PURE__*/ React.createElement(MicrophoneIcon, {
                                                sx: {
                                                    color: '#EB6A2C',
                                                    height: '20px'
                                                }
                                            }),
                                            columnSize: 0
                                        }, {
                                            type: FormItemTypes.IconButton,
                                            name: '',
                                            children: /*#__PURE__*/ React.createElement(MessageIcon, null),
                                            columnSize: 0,
                                            sx: {
                                                color: '#EB6A2C'
                                            }
                                        }]
                                }, {
                                    type: FormItemTypes.Button,
                                    variant: 'text',
                                    name: '',
                                    children: 'Translate to job item *',
                                    columnSize: 0,
                                    sx: {
                                        justifyContent: 'end'
                                    }
                                }]
                        }]
                }]
        }];
    var jobItems = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            columnGap: 2,
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'column',
                    columnSize: 12,
                    gap: '8px',
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            columnGap: 2,
                            elements: [{
                                    type: FormItemTypes.Box,
                                    name: '',
                                    display: 'flex',
                                    columnSize: true,
                                    gap: '16px',
                                    elements: [{
                                            type: FormItemTypes.Box,
                                            name: '',
                                            columnSize: true,
                                            gap: '8px',
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    value: 'Breack pad',
                                                    columnSize: 0,
                                                    fontWeight: 'medium'
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    value: '#01100323',
                                                    columnSize: 0,
                                                    fontWeight: 'normal',
                                                    fontSize: 'sm',
                                                    color: secondary[500]
                                                }]
                                        }, {
                                            type: FormItemTypes.Chip,
                                            name: '',
                                            value: 'P',
                                            color: 'info',
                                            size: 'small',
                                            columnSize: 0
                                        }]
                                }, {
                                    type: FormItemTypes.Icon,
                                    name: 'cross',
                                    columnSize: 0,
                                    children: /*#__PURE__*/ React.createElement(CrossIconSVG, null),
                                    sx: {
                                        color: secondary[500]
                                    }
                                }]
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            columnSize: 12,
                            justifyContent: 'space-between',
                            elements: [{
                                    type: FormItemTypes.NumberInput,
                                    name: '',
                                    label: 'Qty.',
                                    columnSize: 0,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'normal',
                                        overflow: 'visible'
                                    }
                                }, {
                                    type: FormItemTypes.NumberInput,
                                    name: '',
                                    label: 'Amt.',
                                    value: '10000',
                                    columnSize: 0,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1,
                                        textAlign: 'end'
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'normal',
                                        overflow: 'visible'
                                    },
                                    InputProps: {
                                        startAdornment: /*#__PURE__*/ React.createElement(Typography, {
                                            color: secondary[600],
                                            fontSize: 'lg'
                                        }, "\u20B9"),
                                        inputProps: {
                                            sx: {
                                                textAlign: 'end'
                                            }
                                        }
                                    },
                                    disabled: true
                                }]
                        }]
                }, {
                    type: FormItemTypes.Divider,
                    name: 'name',
                    variant: 'fullWidth',
                    columnSize: 12,
                    sx: {
                        mt: '12px'
                    }
                }]
        }];
    var taskDetails = [{
            type: FormItemTypes.Accordian,
            name: 'AdditionalJob',
            xs: 12,
            sm: 12,
            md: 9,
            lg: 9,
            value: false,
            sx: {
                border: '1px solid ',
                borderColor: secondary[200],
                borderRadius: '8px',
                padding: '10px 20px'
            },
            summaryProps: {
                sx: {
                    p: 0,
                    gap: '8px'
                }
            },
            detailPanelProps: {
                spacing: 0,
                padding: '0px 16px 16px 16px',
                gap: '16px'
            },
            summary: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    columnGap: 0.5,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            value: 'Additional jobs',
                            fontWeight: 'strong',
                            required: true,
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Chip,
                            name: '',
                            label: '0',
                            size: 'small',
                            color: 'info'
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            value: '₹ 1,400.00',
                            columnSize: true,
                            fontWeight: 'medium',
                            textAlign: 'right'
                        }]
                }],
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    columnSize: 12,
                    sx: {
                        marginX: '-36px'
                    }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'SerachJobItems',
                    columnSize: 12,
                    label: 'Search',
                    getListData: getPartListAPI,
                    apiKey: ServiceEstimateKeys.PartList,
                    apiRequest: {
                        InstallBaseId: "e3962c78-0d0b-4cfd-92b3-c29a45999f8e",
                        OrganizationId: "c247b74a-8222-4363-b693-0d54a710fa08",
                        SourceAssociationId: "a963d971-3c95-47ba-b029-c4d7abab6f7e"
                    },
                    labelTypographyProps: {
                        fontWeight: 'medium',
                        color: secondary[900],
                        fontSize: 'base'
                    },
                    displayExpr: 'Name',
                    valueExpr: 'id',
                    setFormState: function (state, currValue) { return ({
                        ListItems: [{
                                id: 0,
                                DisplayName: 'Screw',
                                SkuCode: '#032948',
                                Status: 'info'
                            }]
                    }); }
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    value: 'Added jobs',
                    columnSize: 12,
                    fontWeight: 'strong',
                    fontSize: 'lg'
                }, {
                    type: FormItemTypes.List,
                    name: 'ListItems',
                    columnSize: 12,
                    value: null,
                    variant: 'expanded',
                    disableCheckboxSelection: true,
                    disableDetailsPanel: true,
                    getRowHeight: function () { return 'auto'; },
                    elements: jobItems
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: 'end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'outlined',
                            children: 'Save',
                            color: 'primary',
                            columnSize: 0
                        }]
                }]
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'header',
            columnSize: 12,
            paddingInline: '24px',
            position: 'relative',
            m: 0,
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    alignItems: 'center',
                    gap: '16px',
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(LeftArrow, null),
                            sx: {
                                color: secondary[600]
                            },
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            columnSize: true,
                            alignItems: 'center',
                            sx: {
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'start'
                                }
                            },
                            gap: '12px',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'service estimate',
                                    value: 'Service estimate',
                                    fontWeight: 'strong',
                                    fontSize: 'xxl',
                                    columnSize: 0
                                }, {
                                    type: FormItemTypes.Chip,
                                    name: '',
                                    label: 'Status',
                                    color: 'info',
                                    columnSize: 0,
                                    sx: {
                                        borderRadius: '6px',
                                        height: '24px',
                                        fontWeight: 'medium'
                                    },
                                    size: 'medium'
                                }]
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    sx: {
                        flexDirection: {
                            xs: 'column',
                            sm: 'row',
                            md: 'row',
                            lg: 'row'
                        },
                        gap: {
                            xs: "4px",
                            sm: '24px',
                            md: '24px',
                            lg: '24px'
                        }
                    },
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    textAlign: 'center',
                    justifyContent: 'end',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'DOC NO:',
                            value: 'DN-99836628224',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'strong'
                            },
                            columnSize: isMobile ? 12 : 0
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'DOC DATE:',
                            value: '02 Oct, 2024',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'strong'
                            },
                            columnSize: isMobile ? 12 : 0
                        }]
                }]
        }, !isMobile ? {
            type: FormItemTypes.Box,
            name: '',
            height: '68px',
            padding: '16px 24px',
            gap: '12px',
            bgcolor: secondary[100],
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: secondary[200],
            columnSize: 12,
            justifyContent: 'end',
            display: 'flex',
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'text',
                    children: 'Quick links',
                    columnSize: 0,
                    sx: {
                        bgcolor: 'transparent',
                        fontWeight: 'medium'
                    },
                    startIcon: /*#__PURE__*/ React.createElement(LinkSvg, null)
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(Download, null),
                    columnSize: 0,
                    variant: 'outlined',
                    disabled: true,
                    sx: {
                        padding: '8px'
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: /*#__PURE__*/ React.createElement("img", {
                        src: ShareIcon,
                        alt: "",
                        loading: "lazy"
                    }),
                    columnSize: 0,
                    variant: 'outlined',
                    disabled: true,
                    sx: {
                        padding: '8px'
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(PrintIconSVG, null),
                    columnSize: 0,
                    variant: 'outlined',
                    disabled: true,
                    sx: {
                        padding: '8px'
                    }
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    orientation: 'vertical',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'text',
                    children: 'Discard',
                    columnSize: 0,
                    sx: {
                        bgcolor: 'transparent',
                        color: secondary[600],
                        fontWeight: 'medium'
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'contained',
                    children: 'Save',
                    color: 'primary',
                    columnSize: 0
                }]
        } : null, {
            type: FormItemTypes.Tabs,
            name: 'Tabs',
            valueExpr: 'id',
            displayExpr: 'Name',
            columnSize: 12,
            panelGridProps: {
                spacing: 2,
                px: 3,
                pb: '65px'
            },
            tabs: [{
                    id: 'general',
                    Name: 'General',
                    elements: generalTab
                }, {
                    id: 'task-details',
                    Name: 'Task details',
                    elements: taskDetails
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            position: 'fixed',
            bottom: 0,
            right: 0,
            spacing: 0,
            justifyContent: 'end',
            borderTop: '1px solid ',
            borderColor: secondary[200],
            bgcolor: secondary[50],
            padding: '20px 24px',
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'outlined',
                    children: "Next",
                    columnSize: 0
                }]
        }, isMobile ? {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            columnSize: 12,
            sx: {
                borderTop: '1px solid',
                borderColor: secondary[200],
                padding: '16px'
            },
            justifyContent: 'space-between',
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'text',
                    children: 'Discard',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'contained',
                    children: 'Save',
                    columnSize: 0
                }]
        } : null];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        formProps: {
            sx: {
                bgcolor: secondary[50]
            }
        }
    });
};
export default ServiceEstimateDetails;
